/**
 * Recent searches for the search drawer idle panel (layout/theme.liquid, Nike / Amazon / Apple pattern).
 * Saves what the shopper searched (Enter, the "Search for" hint, a suggestion chip, or a result tap)
 * on this device (localStorage, newest first, max 6) and paints them as chips into
 * [data-recent-searches] [data-recent-list] from the <template data-recent-chip>. The idle panel sits
 * in a partial that the live form re-renders, so the list is repainted whenever it is replaced.
 * The chips live inside <s-search-suggest>, so a tap fills the field and runs the search.
 */
const KEY = 'fz-recent-searches';
const MAX = 6;

function read() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((item) => typeof item === 'string' && item.trim()) : [];
  } catch {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* storage unavailable: recent searches are a nicety */
  }
}

function save(term) {
  const clean = String(term || '').trim().replace(/\s+/g, ' ').slice(0, 60);
  if (clean.length < 2) return;
  const list = read().filter((item) => item.toLowerCase() !== clean.toLowerCase());
  list.unshift(clean);
  write(list);
}

function paint() {
  const section = document.querySelector('[data-recent-searches]');
  if (!section) return;
  const holder = section.querySelector('[data-recent-list]');
  const template = section.querySelector('template[data-recent-chip]');
  if (!holder || !template) return;
  const list = read();
  const signature = list.join('\u0001');
  if (holder.dataset.painted === signature && holder.childElementCount === list.length) {
    section.hidden = list.length === 0;
    return;
  }
  holder.replaceChildren();
  for (const term of list) {
    const chip = template.content.firstElementChild.cloneNode(true);
    const url = new URL(chip.getAttribute('href') || '/search', window.location.origin);
    url.searchParams.set('q', term);
    chip.setAttribute('href', url.pathname + url.search);
    chip.dataset.term = term;
    chip.textContent = term;
    holder.append(chip);
  }
  holder.dataset.painted = signature;
  section.hidden = list.length === 0;
}

function input() {
  return document.getElementById('predictive-search-input');
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (form instanceof HTMLFormElement && form.contains(input())) save(input()?.value);
}, true);

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  if (target.closest('[data-recent-clear]')) {
    write([]);
    paint();
    return;
  }
  const chip = target.closest('a[data-term]');
  if (chip && chip.closest('#predictive-search')) {
    save(chip.dataset.term);
    return;
  }
  const link = target.closest('#predictive-search-listbox a[href]');
  if (link) save(input()?.value);
}, true);

const listbox = document.getElementById('predictive-search-listbox');
if (listbox) new MutationObserver(() => paint()).observe(listbox, { childList: true, subtree: true });
paint();

// Results page search box (templates/search.liquid): reopening the drawer fills the field with the searched
// words and runs the type-ahead, so the shopper refines where they first searched.
document.addEventListener('click', (event) => {
  const box = event.target instanceof Element ? event.target.closest('[data-search-prefill]') : null;
  if (!box) return;
  const words = box.getAttribute('data-search-prefill') || '';
  requestAnimationFrame(() => {
    const field = input();
    if (!field) return;
    if (words && field.value !== words) {
      field.value = words;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
    field.focus();
    field.setSelectionRange?.(field.value.length, field.value.length);
  });
});
